import { createFileRoute, notFound } from "@tanstack/react-router";
import { getPage } from "@/content/pages";
import { MarkdownPage } from "@/components/MarkdownPage";
import ServiceContactImage from "@/assets/service-contact.jpg";
import { BookingCalendar } from "@/components/BookingCalendar";
import { bookingBootstrapScript } from "@/lib/bookingBootstrap";

const PAGE_KEY = "/contact";

export const Route = createFileRoute("/contact")({
  loader: () => {
    const page = getPage(PAGE_KEY);
    if (!page) throw notFound();
    return page;
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? [
          { title: loaderData.title },
          { name: "description", content: loaderData.description },
          { property: "og:title", content: loaderData.title },
          { property: "og:description", content: loaderData.description },
      { property: "og:url", content: "https://www.phil-carr.co.uk/contact" },
        ]
      : [],
    links: [{ rel: "canonical", href: "https://www.phil-carr.co.uk/contact" }],
    scripts: [{ id: "booking-availability-bootstrap", children: bookingBootstrapScript }],
  }),
  notFoundComponent: () => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-4xl">Page not found</h1>
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-3xl">Something went wrong</h1>
      <p className="mt-3 text-muted-foreground">{error.message}</p>
    </div>
  ),
  component: Page,
});

function Page() {
  const page = Route.useLoaderData();
  return (
    <>
      <MarkdownPage body={page.body} pageContext={page.title} beforeContent={<BookingCalendar />} formPosition="top" hideDecorativeShapes={true} heroImage={{ src: ServiceContactImage, alt: 'Two people having a friendly conversation over coffee' }} relatedSlugs={["seo-strategy-for-small-businesses-building-consistent-enquiries-in-2026", "how-to-hire-an-seo-consultant", "why-seo-is-still-one-of-the-best-investments-for-growing-businesses"]} />
      <section
        aria-label="Map location"
        className="container mx-auto max-w-7xl px-6 pb-20 lg:px-10"
      >
        <div className="relative overflow-hidden rounded-[10px] border border-border bg-card">
          <iframe
            title="Map of Barnsley, South Yorkshire"
            src="https://www.google.com/maps?q=Barnsley%2C%20South%20Yorkshire%2C%20UK&output=embed"
            className="block aspect-[16/9] w-full border-0 md:aspect-[21/9]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </section>
    </>
  );
}
